export default {"src":"/_next/static/media/microsoft.42b61fa1.svg","height":21,"width":21};